import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DocsApp from "./docs-site/DocsApp";
import "./index.css";

/**
 * The shell around the docs (MOVE.md, "Copy"): this site is the docs and nothing else, so they are
 * served at the domain root (`nav.ts` `DOCS_BASE` is "") and the router gives them every path.
 */
createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<DocsApp />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
